// extracted by mini-css-extract-plugin
export default {"header":"login_header__iYHyf","ssoLoginContainer":"login_ssoLoginContainer__Y5fMk"};